import Preact from 'preact';

var FormStructure = {
    fields: {
        headerLabel: {
            validations: []
        },
        firstName: {
            validations: [
                { type: 'required', message: 'Please provide a first name' }
            ]
        },
        lastName: {
            validations: [
                { type: 'required', message: 'Please provide a last name' }
            ]
        },
        email: {
            validations: [
                { type: 'required', message: 'Please provide an email' },
                { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
            ]
        },
        telNumber: {
            validations: [
                { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' },
                { type: 'required', message: 'Please provide a phone number' }
            ]
        },
        eventDate: {
            validations: [
                { type: 'dateinfuture', message: 'Event date must be in the future' },
                { type: 'required', message: 'Please provide an event date' }
            ]
        },
        plannedguestcount: {
            validations: [
                { type: 'required', message: 'Please provide a guest count' }
            ]
        },
        theme: {
            validations: []
        },
        reference: {
            validations: []
        },
        notes: {
            validations: []
        }
    },
    layout: {
        rows: [{
                fields: [{
                    type: 'text',
                    size: 'Medium',
                    label: 'First Name:*',
                    mapping: 'firstName'
                }]
            },
            {
                fields: [{
                    type: 'text',
                    size: 'Medium',
                    label: 'Last Name:*',
                    mapping: 'lastName'
                }]
            },
            {
                fields: [{
                    type: 'text',
                    size: 'Medium',
                    label: 'Email:*',
                    mapping: 'email'
                }, ]
            },
            {
                fields: [{
                    type: 'text',
                    size: 'Medium',
                    label: 'Phone #:*',
                    mapping: 'telNumber'
                }]
            },
            {
                fields: [{
                    type: 'date-picker',
                    size: 'Medium',
                    label: 'Event Date:*',
                    mapping: 'eventDate'
                }]
            },
            {
                fields: [{
                    type: 'text',
                    size: 'Medium',
                    label: 'Estimated Guest Count:*',
                    mapping: 'plannedguestcount'
                }]
            },
            {
                fields: [{
                    type: 'text',
                    size: 'Medium',
                    label: 'Type of event:',
                    mapping: 'theme'
                }]
            },
            {
                fields: [{
                    type: 'text',
                    size: 'Medium',
                    label: 'How did you hear about us?:',
                    mapping: 'reference'
                }]
            },
            {
                fields: [{
                    type: 'text-area',
                    size: 'Medium',
                    label: 'Would you like to add any details?:',
                    mapping: 'notes'
                }]
            },
            {
                fields: [{
                    type: 'submit',
                    size: 'XLarge',
                    label: 'Submit'
                }]
            }
        ]
    },
    info: {
        title: 'Greysolon by Black Woods Contact Form',
        formId: '740',
        clientKey: '123C1192-5E4A-4A06-9D6F-B7659FC0F825',
        appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
        redirectUrl: '',
        submissionText: 'Thank you! Your web inquiry has been successfully sent. Our team looks forward to connecting with you!',
        apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
    }
};


export default FormStructure;


// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/greysolon/form_structure.js